import BaseService from "./BaseService";
import ProductRebilling, { IProductRebilling, IProductResponse } from "../models/api/ProductRebilling";
import keys from "../config/services";

class ProductRebillingService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  get = async (entityId: string, entityType: string, companyId?: string): Promise<IProductRebilling[]> => {
    try {
      let url = `/billing-config/${entityType}/${entityId}`;
      if(entityType === 'LOCATION'){
        url = url + `?companyId=${companyId}`
      }

      const response = await this.requests.get(url);

      return response.data.map((row) => new ProductRebilling(row as IProductResponse));
    } catch (err) {
      throw err
    }
  }

  update = async (entityType: string, entityId: string, productRebilling: IProductRebilling, companyId?: string) => {
    try {
      let url = `/billing-config/${entityId}`;
      if(entityType === 'LOCATION'){
        url = url + `?companyId=${companyId}`
      }
      const updateData = {
        entityType: entityType,
        product: productRebilling.type,
        config: {
          markup: productRebilling.markup,
          enabled: productRebilling.rebillingEnabled,
          basePrice: productRebilling.price,
          optIn: productRebilling.productOptIn
        }
      }

      await this.requests.put(url,updateData);
    } catch (err) {
      alert(err?.response?.data?.message || "Request failed");
      throw err
    }
  }

  getRebilling = async (companyId: string): Promise<IProductRebilling[]> => {
    try {
      let url = `/rebilling-config/${companyId}`;
      const { data }  = await this.requests.get(url);
      const rebillingData = data.map((row) => new ProductRebilling(row as IProductResponse));
      return rebillingData;
    } catch (err) {
      throw err
    }
  }

  updateRebilling = async (companyId: string, productRebilling: IProductRebilling) => {
    try {
      const updateData = {
        product: productRebilling.type,
        config: {
          markup: productRebilling.markup,
          enabled: productRebilling.rebillingEnabled,
          basePrice: productRebilling.price,
          optIn: productRebilling.productOptIn
        }
      }
      await this.requests.put(`/rebilling-config/${companyId}`,updateData);
    } catch (err) {
      alert(err?.response?.data?.message || "Request failed");
      throw err
    }
  }

  getByProduct = async (entityId: string, entityType: string, product: string, addOptInParam: boolean = false): Promise<IProductRebilling> => {
    try {
      let url = `/billing-config/${entityType}/${entityId}/${product}`;
      if(addOptInParam){
        url = url + "?optIn=true"
      }
      let rebillingData
      const {data}  = await this.requests.get(url);
      rebillingData = new ProductRebilling(data[0] as IProductResponse);

      return rebillingData;
    } catch (err) {
      throw err
    }
  }

  getByProductAndLocation =
    async (
      locationId: string,
      companyId: string,
      product: string): Promise<IProductResponse | undefined> => {
    try {
      let url = `/billing-config/LOCATION/${locationId}/${product}?companyId=${companyId}&optIn=true`;

      const {data} = await this.requests.get(url);
      const productConfig = data[0]

      if (productConfig)
        return productConfig as IProductResponse;
    } catch (err) {
      throw err
    }
  }
}

const instance = new ProductRebillingService(BaseService.servicesConfig.SaaSBillingV2)

export default instance
